import { Col, Row, Accordion, Card } from 'react-bootstrap';
import whatsappContactIcon from 'assets/img/landing/tarjetas/whatsapp-contacto.svg';
import emailContactIcon from 'assets/img/landing/tarjetas/email-contacto.svg';

const AddressSection = () => {
  return (
    <section className="py-10 bg-body-tertiary" id="ubicacion">
      <div className="container-small px-lg-7 px-xxl-3">
        
        {/* Preguntas Frecuentes */}
        <div className="mb-9">
          <h2 className="text-center mb-5fw-bold">Preguntas frecuentes</h2>
          <Accordion flush id="accordionFlushExample" defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="fw-bold">Trabajo en negro y mi empleador me despidió de palabra ¿Qué puedo hacer?</Accordion.Header>
              <Accordion.Body className="text-muted">Como estás en negro tu empleador no va a aceptar despedirte por escrito porque sería reconocer la relación de trabajo. Comunícate con nosotros para realizar el reclamo por la registración, las indemnizaciones y la multa por trabajo no registrado.</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header className="fw-bold">¿Qué indemnización corresponde por despido sin causa?</Accordion.Header>
              <Accordion.Body className="text-muted">Depende del caso en particular. Por lo general, la indemnización incluye: 1 sueldo por año trabajado + 1 sueldo por falta de preaviso (cuando el empleador no te avisó con anticipación que te iba a despedir) + la integración del mes de despido (si te despiden, por ejemplo, a mitad de mes, tienen que pagarte el mes completo) + aguinaldo y vacaciones proporcionales. ¡Para calcular tu indemnización aproximada comunícate con nosotros!</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header className="fw-bold">¿Dónde y cómo realizar más consultas y recibir orientación sobre Derecho Laboral?</Accordion.Header>
              <Accordion.Body className="text-muted">Asesorate con nosotros para resolver todas tus dudas por WhatsApp al 11 5306-9479. El horario de atención es de lunes a viernes de 10 a 19 hs. En el Estudio Parkes, estamos para ayudarlo, nuestra misión principal es su satisfacción.</Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        {/* Ubicación e Iframe */}
        <Row className="g-5 align-items-center mb-10">
          <Col lg={5}>
            <div className="d-flex align-items-center gap-2 mb-3">
              <span className="text-danger fs-3">📍</span>
              <h3 className="mb-0 fw-bold">Nuestra ubicación</h3>
            </div>
            <p className="fs-9">
              <a href="https://maps.app.goo.gl/nLwfhpHBq9P4nMgC8" target="_blank" rel="noreferrer" className="text-body fw-semibold text-decoration-none">
                Piso 1, Oficina A, Mariano Boedo 375, Lomas de Zamora Provincia de Buenos Aires
              </a>
            </p>
            <h4 className="fw-bold mt-4">Horarios de atención</h4>
            <p className="text-muted fs-9">Lunes a viernes <span className="text-primary">→</span> 10HS - 19HS</p>
          </Col>
          <Col lg={7}>
            <div className="ratio ratio-16x9 shadow rounded-3 overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1893.5468890854713!2d-58.402859452659875!3d-34.758915243948714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcd293bc3ca877%3A0x1a3e532bf82d5d85!2sPARKES%20ABOGADOS!5e0!3m2!1ses!2sar!4v1739721764707!5m2!1ses!2sar" 
                style={{ border: 0 }} 
                allowFullScreen={true} 
                loading="lazy" 
                title="Google Maps Estudio Parkes"
              ></iframe>
            </div>
          </Col>
        </Row>

        {/* Tarjetas de Contacto */}
        <div id="contacto" className="pt-5">
          <h2 className="text-center mb-3 fw-bold">Contacto</h2>
          <p className="text-center text-muted mb-6 px-lg-8">Si tienes alguna consulta o necesitas asesoramiento legal, no dudes en contactarnos. Nuestro equipo está listo para brindarte la atención personalizada que mereces.</p>
          
          <Row className="g-4 justify-content-center">
            <Col xs={12} md={6} lg={5}>
              <Card className="h-100 border-0 shadow-sm text-center p-4">
                <Card.Body>
                  <img src={whatsappContactIcon} alt="WhatsApp" className="mb-3" width="50" />
                  <h4 className="fw-bold mb-2">WhatsApp</h4>
                  <p className="text-muted fs-9 mb-4">Envíanos un mensaje directamente a nuestro WhatsApp y te atenderemos de manera rápida y eficiente. Estamos disponibles para resolver tus dudas.</p>
                  <a href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" className="btn btn-success rounded-pill px-4" target="_blank" rel="noreferrer">Ir a WhatsApp</a>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={6} lg={5}>
              <Card className="h-100 border-0 shadow-sm text-center p-4">
                <Card.Body>
                  <img src={emailContactIcon} alt="Email" className="mb-3" width="50" />
                  <h4 className="fw-bold mb-2">Email</h4>
                  <p className="text-muted fs-9 mb-4">Si prefieres contactarnos por email, envíanos tus consultas a nuestro correo corporativo. Nuestro equipo revisará tu mensaje a la brevedad.</p>
                  <a href="mailto:jap@estudioparkes.com" className="text-primary fw-bold text-decoration-none fs-8">jap@estudioparkes.com</a>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

      </div>
    </section>
  );
};

export default AddressSection;